import { THEME, ThemeName } from '@/config/theme';

// Direct import of the available themes
import * as lemon from './lemon';
// Uncomment once these themes are created:
// import * as numerama from './numerama';
// import * as frandroid from './frandroid';

type ThemeModule = typeof lemon;

const themes: Partial<Record<ThemeName, ThemeModule>> = {
  lemon,
  // numerama,
  // frandroid,
};

const themeModule = themes[THEME];

if (!themeModule) {
  throw new Error(`Theme "${THEME}" not found. Available: ${Object.keys(themes).join(', ')}`);
}

export const { Header, Footer, Layout } = themeModule;
